import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import times from 'utils/times'
import { Row, Col, Image, Card, CardBlock, ButtonGroup, Button, SVGIcon } from 'components/qstrap'

const RiasecExample = () => (
  <Card>
    <CardBlock>
      <p className="text-center">{intl.get('aptitude.questions.bar.riasec.example')}</p>
      <div className="AptitudeQuestionItemRiasec">
        {
        times(5, (i) => {
          const img = ((i + 1) === 5) ? 'color' : 'grey'

          return (
            <Image
              key={i}
              src={`/assets/img/riasec_emoji/${i + 1}/${img}.svg`}
            />
          )
        })
      }
      </div>
    </CardBlock>
  </Card>
)

const CharcsExample = () => (
  <Card>
    <CardBlock>
      <Row className="m-b-md">
        <Col sm="6" md="6" className="question-text col-xs-6">
          <b>{intl.get('aptitude.questions.bar.charcs.example_1')}</b>
        </Col>
        <Col sm="6" md="6" className="question-text col-xs-6 text-right">
          <b>{intl.get('aptitude.questions.bar.charcs.example_2')}</b>
        </Col>
      </Row>
      <ButtonGroup className="full-width">
        <Button className="charcs-btn w-25">
          <div><SVGIcon name="common-back" size="sm" /><SVGIcon name="common-back" /></div>
        </Button>
        <Button className="charcs-btn w-25">
          <SVGIcon name="common-back" />
        </Button>
        <Button className="charcs-btn w-25">
          <SVGIcon name="common-next" />
        </Button>
        <Button className="charcs-btn w-25 active">
          <div><SVGIcon name="common-next" /><SVGIcon name="common-next" size="sm" /></div>
        </Button>
      </ButtonGroup>
    </CardBlock>
  </Card>
)

const Example = ({ factor }) => {
  if (factor === 'riasec') {
    return <RiasecExample />
  }
  return <CharcsExample />
}

Example.propTypes = {
  factor: PropTypes.string.isRequired,
}

export default Example
